import './share.scss';

const ShareComponent = {
  el: null,

  init() {
    this.setupShare();

    window.addEventListener('setupShareTraining', this.setupShareTraining.bind(this));
  },
  setupShare: function setupShare() {
      this.el = document.querySelectorAll('[share]');
      this.el.forEach((elem) => {
        elem.addEventListener('click', () => {
          var tempInput = document.createElement("input");
          tempInput.style = "position: absolute; left: -1000px; top: -1000px";
          tempInput.value = window.location.href;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand("copy");
          document.body.removeChild(tempInput);
          elem.querySelectorAll('.copied')[0].classList.add('active')
        });
      })
  },
  setupShareTraining: function setupShare() {
      this.el = document.querySelectorAll('[share]');
      this.el.forEach((elem) => {
        elem.addEventListener('click', () => {
          var tempInput = document.createElement("input");
          tempInput.style = "position: absolute; left: -1000px; top: -1000px";
          tempInput.value = window.location.hostname + '/gen8training';
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand("copy");
          document.body.removeChild(tempInput);
          elem.querySelectorAll('.copied')[0].classList.add('active')
        });
      })
  },
};

export default ShareComponent;
